import { useNavigate, useParams } from 'react-router-dom'

const content: Record<string, { title: string; body: string }> = {
  contact: {
    title: "Contact Us",
    body: `AITradeMinds is operated by SG Tech Solutions, Kolkata, India.

Email: support@aitrademinds.in

For subscription queries, signal feedback, or technical issues, 
email us and we will respond within 24 business hours.

We do not provide investment advice. AITradeMinds is a research 
intelligence tool for experienced NSE F&O traders.`
  },
  terms: {
    title: "Terms & Conditions",
    body: `Last updated: July 2026

1. SERVICE DESCRIPTION
AITradeMinds provides NSE F&O options flow intelligence data. 
All signals are for research purposes only and do not constitute 
investment advice or SEBI-registered research.

2. SUBSCRIPTION
Subscriptions are billed monthly at ₹499 (Basic), ₹999 (Pro), 
or ₹1,999 (Elite). Access continues until the end of the billing period.

3. DISCLAIMER
Trading in F&O instruments involves substantial risk of loss. 
Past signal accuracy does not guarantee future results. 
Users are solely responsible for their trading decisions.

4. DATA ACCURACY
Signal data is sourced from NSE via Kite Connect API. 
We do not guarantee real-time accuracy or completeness.

5. GOVERNING LAW
These terms are governed by the laws of India. 
Disputes subject to jurisdiction of courts in Kolkata, West Bengal.`
  },
  refunds: {
    title: "Refunds & Cancellations",
    body: `Last updated: July 2026

CANCELLATION POLICY
You may cancel your subscription at any time from your account settings.
Cancellation takes effect at the end of the current billing period.
You will retain access until the period end date.

REFUND POLICY
We offer a 7-day refund policy for first-time subscribers.
If you are unsatisfied within 7 days of your first payment, 
email support@aitrademinds.in for a full refund.

No refunds are issued for:
- Renewals after the first billing cycle
- Partial month usage
- Accounts found to be misusing the service

PROCESSING TIME
Approved refunds are processed within 5-7 business days 
to the original payment method via Cashfree.`
  }
}

export default function Legal() {
  const { page } = useParams<{ page: string }>()
  const navigate = useNavigate()
  const c = content[page || 'contact']

  if (!c) {
    navigate('/')
    return null
  }

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <span style={styles.logo} onClick={() => navigate('/')}>
          AITradeMinds
        </span>
      </div>
      <div style={styles.content}>
        <h1 style={styles.title}>{c.title}</h1>
        <div style={styles.body}>
          {c.body.split('\n\n').map((para, i) => (
            <p key={i} style={styles.para}>{para}</p>
          ))}
        </div>
        <button style={styles.back} onClick={() => navigate('/')}>
          ← Back to Home
        </button>
      </div>
    </div>
  )
}

const styles: Record<string, React.CSSProperties> = {
  container: { background: '#0a0e1a', minHeight: '100vh', color: '#fff' },
  header: {
    padding: '20px 40px',
    borderBottom: '1px solid #1f2937',
    background: '#0d1117',
  },
  logo: {
    color: '#00d4ff', fontSize: 20, fontWeight: 700, cursor: 'pointer'
  },
  content: { maxWidth: 720, margin: '0 auto', padding: '48px 24px' },
  title: { fontSize: 28, fontWeight: 700, marginBottom: 32 },
  body: { color: '#9ca3af', lineHeight: 1.8 },
  para: { marginBottom: 20, whiteSpace: 'pre-wrap' as const },
  back: {
    marginTop: 40, background: 'transparent', color: '#00d4ff',
    border: '1px solid #00d4ff', padding: '10px 24px',
    borderRadius: 6, cursor: 'pointer', fontSize: 14,
  },
}